// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1iHJE","content":"styles_content__2o_y-","checkbox":"styles_checkbox__3nxuf","checkboxLabel":"styles_checkboxLabel__14S57"};